export default class ActivityController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/activity/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/activity/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/activity/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/activity/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/activity/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/activity/delete', 'post', params, axiosOption, httpOption);
  }

  static startOnlyFlowActivity (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/activity/startOnly/flowActivity', 'post', params, axiosOption, httpOption);
  }

  static startWithBusinessKeyFlowActivity (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/activity/startWithBusinessKey/flowActivity', 'post', params, axiosOption, httpOption);
  }

  static startAndTakeUserTaskFlowActivity (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/activity/startAndTakeUserTask/flowActivity', 'post', params, axiosOption, httpOption);
  }

  static startAndSaveDraftFlowActivity (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/activity/startAndSaveDraft/flowActivity', 'post', params, axiosOption, httpOption);
  }

  static submitUserTaskFlowActivity (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/activity/submitUserTask/flowActivity', 'post', params, axiosOption, httpOption);
  }

  static viewTaskBusinessDataFlowActivity (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/activity/viewTaskBusinessData/flowActivity', 'get', params, axiosOption, httpOption);
  }

  static viewHistoricTaskBusinessDataFlowActivity (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/activity/viewHistoricTaskBusinessData/flowActivity', 'get', params, axiosOption, httpOption);
  }

  static listWorkOrderFlowActivity (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/activity/listWorkOrder/flowActivity', 'post', params, axiosOption, httpOption);
  }
}
